import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { authGuard } from '@core/guards/auth.guard';
import { notLoggedInGuard } from '@core/guards/not-logged-in.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/landing-page/landing-page.module').then(
        m => m.LandingPageModule
      ),
  },
  {
    path: 'info.html',
    loadComponent: () =>
      import('./core/components/health-checker/health-checker.component').then(
        standaloneComponent => standaloneComponent.HealthCheckerComponent
      ),
  },
  {
    path: 'sobre-nos.html',
    loadChildren: () =>
      import('./pages/about-us/about-us.module').then(m => m.AboutUsModule),
  },
  {
    path: 'resultados',
    loadChildren: () =>
      import('./pages/raffle-results/raffle-results.module').then(
        m => m.RaffleResultsModule
      ),
  },
  {
    path: 'ganhadores/:type',
    redirectTo: '/resultados/:type',
  },
  {
    path: 'instituicao-beneficiada',
    loadChildren: () =>
      import('./pages/about-santa-casa/about-santa-casa.module').then(
        m => m.AboutSantaCasaModule
      ),
  },
  {
    path: 'ajuda',
    loadChildren: () =>
      import('@pages/help/help.module').then(m => m.HelpModule),
  },
  {
    path: 'protocolo',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/contact-protocol/contact-protocol.module').then(
        m => m.ContactProtocolModule
      ),
  },
  {
    path: 'carrinho.html',
    loadChildren: () =>
      import('./pages/cart/cart.module').then(m => m.CartModule),
  },
  {
    path: 'login.html',
    canActivate: [notLoggedInGuard],
    loadChildren: () =>
      import('./pages/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'redefinir-senha',
    loadChildren: () =>
      import('./pages/reset-password/reset-password.module').then(
        m => m.ResetPasswordModule
      ),
  },
  {
    path: 'meus-resultados',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/my-results/my-results.module').then(
        m => m.MyResultsModule
      ),
  },
  {
    path: 'meus-pedidos',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/my-orders/my-orders.module').then(m => m.MyOrdersModule),
  },
  {
    path: 'meus-titulos',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/my-tickets/my-tickets.module').then(
        m => m.MyTicketsModule
      ),
  },
  {
    path: 'politicas-e-termos',
    loadChildren: () =>
      import('./pages/terms-and-policies/terms-and-policies.module').then(
        m => m.TermsAndPoliciesModule
      ),
  },
  {
    path: 'pre-cadastro.html',
    loadChildren: () =>
      import('./pages/pre-register/pre-register.module').then(
        m => m.PreRegisterModule
      ),
  },
  {
    path: 'pre-cadastro/verificacao-de-codigo.html',
    loadChildren: () =>
      import(
        './pages/pre-register/components/confirm-pre-registration/confirm-pre-registration.module'
      ).then(m => m.ConfirmPreRegistrationModule),
  },
  {
    path: 'pagamento',
    loadChildren: () =>
      import('./pages/payment/payment.module').then(m => m.PaymentModule),
  },
  {
    path: 'cadastro',
    loadChildren: () =>
      import('./pages/user-registration/user-registration.module').then(
        m => m.UserRegistrationModule
      ),
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
